import {
  approvalPolicyOptionsQuery,
  workspaceApprovalPoliciesQuery,
} from "@common/api/approval-policies"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"
import { duplicateDefaults } from "../-components/form/schema"
import { PolicyMissing } from "../-components/policy-missing"
import { PolicyPage } from "../-components/policy-page"
import { CREATE_FLOWS_PERMISSION } from "../-lib/permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/approval-flows/duplicate/$policyId",
)({
  staticData: { breadcrumb: "Duplicate flow" },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      CREATE_FLOWS_PERMISSION,
      "/settings/workspace/general",
    ),
  loader: async ({ context: { queryClient }, params: { policyId } }) => {
    const [policies] = await Promise.all([
      queryClient.ensureQueryData(workspaceApprovalPoliciesQuery()),
      queryClient.ensureQueryData(approvalPolicyOptionsQuery()),
    ])
    if (!policies.policies.some((entry) => entry.policy.id === policyId)) {
      throw redirect({
        to: "/settings/workspace/approval-flows",
        replace: true,
      })
    }
  },
  component: DuplicatePolicyPage,
})

function DuplicatePolicyPage(): React.ReactElement {
  const { policyId } = Route.useParams()
  const { data } = useSuspenseQuery(workspaceApprovalPoliciesQuery())
  const source = data.policies.find((entry) => entry.policy.id === policyId)

  return source ? (
    <PolicyPage
      key={policyId}
      policy={undefined}
      defaults={duplicateDefaults(source.policy)}
    />
  ) : (
    <PolicyMissing />
  )
}
